<template>
  <div v-if="isActive" class="multimedia__content-scroll">
    <vue-scroll>
      <slot></slot>
    </vue-scroll>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    selected: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    hasIcon() {
      return this.icon !== '';
    },
  },
  mounted() {
    this.isActive = this.selected;
  },
};
</script>
